import React from "react";
import * as RelationUtils from "utils/relation";
import { customMapper } from "utils/select";
import { Labeled, MappedCategoricalValueInput } from "components/Tiles/Sense/Relation/Common";
import PivotRelationInput from "./PivotRelationInput";
import UnpivotRelationInput from "./UnpivotRelationInput";
import UnpivotAndPivotRelationInput from "./UnpivotAndPivotRelation";
const PivotingRelationInput = ({ relation, onChange, isDisabled }) => {
    switch (relation.type) {
        case "PIVOT":
            return React.createElement(PivotRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "UNPIVOT":
            return React.createElement(UnpivotRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
        case "UNPIVOT_PIVOT":
            return React.createElement(UnpivotAndPivotRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled });
    }
};
function getDefaultForType(type, defaultFactory) {
    switch (type) {
        case "PIVOT":
            return defaultFactory.pivot();
        case "UNPIVOT":
            return defaultFactory.unpivot();
        case "UNPIVOT_PIVOT":
            return defaultFactory.unpivotAndPivot();
    }
}
const ToggleablePivotingRelationInput = ({ relation, onChange, isDisabled }) => {
    const defaultFactory = new RelationUtils.DefaultRelationFactory(RelationUtils.builder(relation.input));
    return (React.createElement("div", null,
        React.createElement(Labeled, { isBold: true, label: "Type", style: { marginBottom: "10px" } },
            React.createElement(MappedCategoricalValueInput, { value: relation.type, onChange: (type) => {
                    const t = type ?? "PIVOT";
                    if (t !== relation.type) {
                        onChange(getDefaultForType(t, defaultFactory));
                    }
                }, values: ["PIVOT", "UNPIVOT", "UNPIVOT_PIVOT"], mapper: customMapper((type) => {
                    switch (type) {
                        case "PIVOT":
                            return "Pivot (Long to Wide)";
                        case "UNPIVOT":
                            return "Unpivot (Wide to Long)";
                        case "UNPIVOT_PIVOT":
                            return "Unpivot and Pivot";
                    }
                }), selectOnly: true })),
        React.createElement(PivotingRelationInput, { relation: relation, onChange: onChange, isDisabled: isDisabled })));
};
export default ToggleablePivotingRelationInput;
